import { render, staticRenderFns } from "./GlassesNeed.vue?vue&type=template&id=176b782f&"
import script from "./GlassesNeed.vue?vue&type=script&lang=js&"
export * from "./GlassesNeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports